import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IPermissionsRequestsToastPresenter {
  call: Call;
  isSidebarVisible: boolean;
  permissionsRequestsCount: number;
  showRequests(): void;
}

export const usePermissionsRequestsToastPresenter = (): IPermissionsRequestsToastPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IPermissionsRequestsToastPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    get isSidebarVisible(): boolean {
      return presenter.call.viewState.isPermissionsRequestsShown;
    },

    get permissionsRequestsCount(): number {
      return presenter.call.permissions.permissionsRequestsCount;
    },

    showRequests(): void {
      if (!context.call.viewState.isMembersShown) {
        context.call.viewState.showMembers();
      }

      context.call.viewState.showPermissionsRequests();
    },
  }));

  return presenter;
};
